import ConfigValueChange from "./ui/ConfigValueChange.jsx";
import { settingKnowledge } from "../pages/agentPolicy/chat/knowledge.js";

const TITLES = {
    "/permissions/ask": "Tool calls requiring approval", "/permissions/deny": "Blocked tool calls",
    "/permissions/allow": "Allowed tool calls", "/rules/prefix_rules": "Command permission rules",
};

function RuleValue({ value }) {
    if (typeof value === "string") return <code className="whitespace-pre-wrap [overflow-wrap:anywhere]">{value}</code>;
    const decisions = { prompt: "Require approval", forbidden: "Block", allow: "Allow" };
    if (!Array.isArray(value?.pattern) || !value.pattern.length || !decisions[value.decision]
        || !value.pattern.every((part) => typeof part?.token === "string" || Array.isArray(part?.any_of) && part.any_of.every((token) => typeof token === "string"))) {
        return <code className="whitespace-pre-wrap [overflow-wrap:anywhere]">{JSON.stringify(value, null, 2)}</code>;
    }
    const command = value.pattern.map((part) => typeof part.token === "string" ? /\s/.test(part.token) ? JSON.stringify(part.token) : part.token
        : Array.isArray(part.any_of) ? `[${part.any_of.map((token) => JSON.stringify(token)).join(" | ")}]` : JSON.stringify(part)).join(" ");
    return <div className="grid gap-[3px]">
        <span className="text-[12px] font-medium">{decisions[value.decision]}</span>
        <code className="whitespace-pre-wrap [overflow-wrap:anywhere]">{command}</code>
        {value.justification ? <p className="m-0 text-[12px] text-[color:var(--muted)]">{value.justification}</p> : null}
    </div>;
}

export default function ControlSettingChange({ agentId, edit, current, explanation }) {
    const title = TITLES[edit.pointer] || settingKnowledge(agentId, edit.pointer)?.label || edit.pointer;
    const rules = edit.pointer.startsWith("/permissions/") && ["ask", "allow", "deny"].includes(edit.pointer.split("/").at(-1)) || edit.pointer === "/rules/prefix_rules";
    return <section aria-label={title} data-control-setting={edit.pointer} className="grid min-w-0 gap-[8px] border-t border-[color:var(--line-soft)] py-[12px]">
        <div className="grid min-w-0 gap-[3px]">
            <h5 className="m-0 text-[13px] font-medium">{title}</h5>
            {title !== edit.pointer ? <code className="break-all text-[11px] text-[color:var(--muted)]">{edit.pointer}</code> : null}
        </div>
        <ConfigValueChange beforeFound={current.found} before={current.value} afterFound={edit.afterFound} after={edit.after}
            {...(rules ? { renderValue: (value) => <RuleValue value={value} /> } : {})} />
        {explanation ? <p className="m-0 text-[12px] leading-[1.5] text-[color:var(--muted)]">{explanation}</p> : null}
    </section>;
}
